// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1kMB5","col":"CardReaderDesc_col__2YUgI","label":"CardReaderDesc_label__ybtm8"};